'use client';

import { useState } from 'react';
import { ListGroup } from 'react-bootstrap';

function highlightMatch(text, term) {
  if (!term) {
    return text;
  }

  const regex = new RegExp(`(${term})`, 'gi');
  const parts = String(text || '').split(regex);

  return parts.map((part, index) =>
    part.toLowerCase() === term.toLowerCase() ? (
      <mark key={index} className="bg-warning-subtle px-0">
        <span className="highlight-text">{part}</span>
      </mark>
    ) : (
      part
    ),
  );
}

function CategoryTreeItem({ cat, level, fullTree, onSelect, searchTerm }) {
  const [expanded, setExpanded] = useState(level < 1);
  const hasChildren = cat.children?.length > 0;

  return (
    <>
      <ListGroup.Item
        action
        onClick={() => onSelect?.(cat)}
        className={`fs-7 fs-msm-6 py-1 pe-1 ps-${Math.min(
          level * 2,
          5,
        )} d-flex align-items-center gap-2`}
      >
        <span>{cat.icon || '📂'}</span>
        <span className="flex-grow-1">
          {highlightMatch(cat.name, searchTerm)}
        </span>

        {hasChildren ? (
          <span
            className="ms-auto text-muted"
            onClick={(event) => {
              event.stopPropagation();
              setExpanded(!expanded);
            }}
          >
            {expanded ? '▾' : '▸'}
          </span>
        ) : null}
      </ListGroup.Item>

      {expanded && hasChildren ? (
        <CategoryTreeMap
          categories={cat.children}
          level={level + 1}
          fullTree={fullTree}
          onSelect={onSelect}
          searchTerm={searchTerm}
        />
      ) : null}
    </>
  );
}

export default function CategoryTreeMap({
  categories,
  level = 0,
  fullTree,
  searchTerm,
  onSelect,
}) {
  if (!categories?.length) {
    return null;
  }

  return (
    <ListGroup variant="flush" className={level === 0 ? '' : 'ms-2'}>
      {categories.map((cat) => (
        <CategoryTreeItem
          key={cat.categoryNumber}
          cat={cat}
          level={level}
          fullTree={fullTree || categories}
          onSelect={onSelect}
          searchTerm={searchTerm}
        />
      ))}
    </ListGroup>
  );
}
